import { render, staticRenderFns } from "./PowerSummarizerContent.vue?vue&type=template&id=7f924e24&scoped=true"
import script from "./PowerSummarizerContent.vue?vue&type=script&lang=js"
export * from "./PowerSummarizerContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f924e24",
  null
  
)

export default component.exports